import _toArray from "@babel/runtime/helpers/toArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import map from 'lodash/map';
export default (function () {
  var gutterBlocks = {};
  return [{
    commands: {
      registerGutterBlock: function registerGutterBlock(editor, _ref) {
        var nodeId = _ref.nodeId,
            gutterBlockType = _ref.gutterBlockType,
            onUpdate = _ref.onUpdate;
        gutterBlocks[nodeId] = _objectSpread({}, gutterBlocks[nodeId] || {}, _defineProperty({}, gutterBlockType, {
          onUpdate: onUpdate,
          priorities: [{
            origin: 'default',
            priority: 1
          }]
        }));
      },
      unregisterGutterBlock: function unregisterGutterBlock(editor, _ref2) {
        var origin = _ref2.origin,
            nodeId = _ref2.nodeId,
            gutterBlockType = _ref2.gutterBlockType;

        if (gutterBlocks[nodeId] && gutterBlocks[nodeId][gutterBlockType]) {
          delete gutterBlocks[nodeId][gutterBlockType];
        } else if (!gutterBlocks[nodeId]) {
          delete gutterBlocks[nodeId];
        }
      },
      updateGutterBlock: function updateGutterBlock(editor, _ref3) {
        var origin = _ref3.origin,
            gutterBlockType = _ref3.gutterBlockType,
            nodeId = _ref3.nodeId,
            priority = _ref3.priority;
        var gutterNode = gutterBlocks[nodeId];
        if (!gutterNode) return;
        var gutterBlockTypes = !Array.isArray(gutterBlockType) ? [gutterBlockType] : gutterBlockType;
        gutterBlockTypes.forEach(function (type) {
          var gutterBlock = gutterBlocks[nodeId][type];

          if (gutterBlock) {
            gutterBlock.priorities = [].concat(_toConsumableArray(priority !== undefined ? [{
              origin: origin,
              priority: priority
            }] : []), _toConsumableArray(gutterBlock.priorities.filter(function (prio) {
              return prio.origin !== origin;
            })));
          }
        });
        var sortedPriorities = sortBy(groupBy(map(gutterNode, function (node) {
          return _objectSpread({}, node, {
            priority: node.priorities[0].priority
          });
        }), 'priority'), 'key').reverse(); // Show gutters block with highter priority (last in the sortedPriority list), hide the other ones

        var _sortedPriorities = _toArray(sortedPriorities),
            toShow = _sortedPriorities[0],
            toHide = _sortedPriorities.slice(1);

        toShow && toShow.forEach(function (_ref4) {
          var onUpdate = _ref4.onUpdate,
              priority = _ref4.priority;
          return onUpdate(!!priority);
        });
        toHide && toHide.forEach(function (group, index) {
          return group.forEach(function (_ref5) {
            var onUpdate = _ref5.onUpdate,
                priority = _ref5.priority;
            return onUpdate(false);
          });
        });
      }
    }
  }];
});